import { render } from "./PlaceholderSegment.vue?vue&type=template&id=6e0b510b"
import script from "./PlaceholderSegment.vue?vue&type=script&lang=js"
export * from "./PlaceholderSegment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__